/* A series is a set-navigation choice, never a combined result filter. */
(() => {
  const root = document.querySelector('[data-lichcards-singles-index]');
  if (!root || root.dataset.ready === 'true' || root.dataset.seriesChoice === 'active') return;
  const parameters = new URLSearchParams(window.location.search);
  const allowed = new Set(['game', 'series', 'preview_theme_id']);
  if (Array.from(parameters.keys()).some(key => !allowed.has(key))) return;
  if (parameters.getAll('game').length !== 1 || parameters.get('game') !== 'pokemon' || parameters.getAll('series').length !== 1) return;
  const chooser = root.querySelector('[data-index-series-chooser]');
  const heading = root.querySelector('[data-index-series-heading]');
  const panel = Array.from(chooser?.querySelectorAll('[data-index-series-choice]') || [])
    .find(item => item.dataset.indexSeriesChoice === parameters.get('series'));
  if (!panel || !heading || !panel.querySelector('.lc-series-choice__link[href]')) return;

  const ordinary = Array.from(root.querySelectorAll('[data-index-series-ordinary]'));
  const focused = document.activeElement;
  const restoreFocus = focused instanceof HTMLElement && focused.getClientRects().length > 0 && ordinary.some(element => element.contains(focused));
  ordinary.forEach(element => {
    element.hidden = true;
    element.inert = true;
  });
  heading.textContent = panel.dataset.seriesHeading;
  const eyebrow = root.querySelector('[data-index-eyebrow]');
  if (eyebrow) eyebrow.textContent = `Pokémon · ${panel.dataset.seriesTitle}`;
  panel.hidden = false;
  chooser.hidden = false;
  root.dataset.seriesChoice = 'active';
  if (restoreFocus && (document.activeElement === focused || document.activeElement === document.body)) {
    panel.querySelector('.lc-series-choice__link[href]').focus();
  }
})();
